jQuery(document).on('page.ready', function () {
    $ = jQuery;

    var Params = (function (strParam) {
        var objParams = {};

        function pullParams() {
            // get url parameters
            var arrURLParams = window.location.search.replace('?', '').split('&');
            // obj placeholder for params
            objParams = {};
            // convert parameters into an object
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                if (!arrPair[0]) { return false };
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }

        function getParam(strParam) {
            pullParams();

            return objParams[strParam];
        }

        function setParam(name, value) {
            pullParams();

            var newParams = objParams;

            if (value === null) {
                delete newParams[name];
            } else {
                newParams[name] = value;
            }

            var paramsURL = Object.keys(newParams).map(function (key, val) { return [key, newParams[key]].join('=') }).join('&');

            var newURL = location.pathname;
            if (paramsURL.length) { newURL += "?" + paramsURL; }
            window.history.replaceState(null, null, newURL);

        }
        console.log(objParams);

        return {
            get: getParam,
            set: setParam
        }
    }());

    if ($('main.blog-overview').length) {
        console.log('This is the blog-overview page');

        $('.newscard').each(function (index, el) {
            if (index > 2) {
                $(el).css('height', '0');
            } else {
                $(el).addClass('showing');
            }
        }); //Hide all .newscard elements on page load, make them show with a load more button

        $('.written button.more').click(function (event) {
            $('.newscard').each(function (index, el) {

                if ($(window).width() > 950) {
                    var cHeight = $(el).children('.post-content').height();
                    $(el).css('height', cHeight);
                    $(el).addClass('showing');

                } else {
                    var totalHeight = 0;
                    $(el).children().each(function () {
                        totalHeight = totalHeight + $(this).outerHeight(true);
                    });
                    $(el).css('height', totalHeight);
                    $(el).addClass('showing');
                }
            });

            $(this).css('display', 'none');
            $(this).addClass('clicked');
        });

        $blogs = $('.blogs .container');
        $blogs.flickity({
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: true,
            draggable: true,
            adaptiveHeight: true,
            selectedAttraction: 0.02,
            friction: 0.22
        });

        $realstories = $('.realstories .container');
        $realstories.flickity({
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: true,
            draggable: true,
            adaptiveHeight: true,
            selectedAttraction: 0.02,
            friction: 0.22
        });

        if ($(window).width() > 950) {
            $vids = $('.videos .container');
            $vids.flickity({
                //autoPlay: 9000,
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: true,
                draggable: false,
                adaptiveHeight: true,
                groupCells: 3,
                selectedAttraction: 0.02,
                friction: 0.22
            });
        }

        /**********************************************************************
    	Resouces Page - Filter news/blog posts by category functionality
  	***********************************************************************/
        $('.filter-nav button').click(function (event) {
            var me = $(this);

            if (!$('button.more').hasClass('clicked')) {
                $('button.more').trigger('click'); //if they're filtering, just show all news/pdfs
                $('button.more').addClass('clicked');
            }

            // if what you clicked is already active, remove all filters & show all posts
            if ($(this).hasClass('active')) {
                $('.filter-nav button').removeClass('active');

                Params.set('filter', null);

                $('article.post').each(function (index, el) {

                    showPosts(el);

                });
            } else {

                var cat = me.data('cat');
                $('.filter-nav button').removeClass('active');
                $(me).addClass('active');

                Params.set('filter', cat);

                $('article.post').each(function (index, el) {
                    $(el).data('cat');

                    if (cat != $(el).data('cat')) { //if the post category doesn't match the button clicked

                        hidePosts(el);

                    } else { // then show the post, because it will match
                        showPosts(el);
                    }

                });
            }

            remakeFlickity();
        });

        function hidePosts(el) {
            if ($(el).hasClass('vidcard')) { //videos only
                if ($(window).width() > 950) { //on computers only
                    $(el).removeClass('is-selected').appendTo('#vidhold');
                } else { // otherwise, we just hide it on mobile/tablet
                    $(el).addClass('hide');
                }
            }

            if ($(el).hasClass('newscard')) { //news/pdfs only
                $(el).addClass('hide');
            }

            if ($(el).hasClass('blogcard')) { //blog posts only
                $(el).removeClass('is-selected').appendTo('#bloghold');
            }
        }

        function showPosts(el) {
            if ($(el).hasClass('vidcard')) { //videos only
                if ($(window).width() > 950) { //on computers only
                    $vids.flickity('insert', $(el));
                } else { // otherwise, we just hide it on mobile/tablet
                    $(el).removeClass('hide');
                }
            }

            if ($(el).hasClass('newscard')) { //news/pdfs only
                $(el).removeClass('hide');
            }

            if ($(el).hasClass('blogcard')) { //blog posts only
                $blogs.flickity('insert', $(el));
            }
        }

        function remakeFlickity() {

            $blogs.flickity('destroy');
            if ($(window).width() > 950) {
                $vids.flickity('destroy');
            }

            $blogs.flickity({
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: true,
                draggable: true,
                adaptiveHeight: true,
                selectedAttraction: 0.02,
                friction: 0.22
            });

            if ($(window).width() > 950) {
                $vids = $('.videos .container');
                $vids.flickity({
                    //autoPlay: 9000,
                    cellAlign: 'left',
                    prevNextButtons: false,
                    pageDots: true,
                    draggable: false,
                    adaptiveHeight: true,
                    groupCells: 3,
                    selectedAttraction: 0.02,
                    friction: 0.22
                });
            }
        }

        var ParamFilter = (function () {
            var filter = Params.get('filter');

            if (filter) { $('.filter-nav button[data-cat="' + filter + '"]').trigger('click'); }
        }());

    } //end page check

});